export type Environment = {
  name: "development" | "production" | "test";
  apiUrl: string;
};

export const environment = {
  name: process.env.NODE_ENV,
  apiUrl: 'http://localhost:5159/api',
} as Environment;
